namespace AgerLMS.Coaching {
    export interface StockData {
        startDate?: string;
        endDate?: string;
        data?: number[];
        avg?: number;
        total?: number;
    }
}
